import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import Button from '../../../components/button';
import CustomModal from '../../../components/CustomModal';
import Input from '../../../components/input';
import Select from '../../../components/Select';
import { updatePartMakeAsync, fetchPartMakes, getPartMakesOverview } from '../../../store/Slices/PartMakeSlice';
import { partMakeValidationSchema } from '../../../utils/Schema';
import { partModelStatusOptions } from '../../../utils/Dropdowns';
import { errorNotify, successNotify } from '../../../utils/toast';

const UpdatePartMakeModal = ({ show, onHide, partMake, currentPage, limit }) => {
    const dispatch = useDispatch();
    const { updatePartMakeLoading } = useSelector((state) => state.partMakes);

    const initialValues = {
        name: partMake?.name || '',
        status: partMake?.status || 'active'
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const payload = {
                id: partMake.id,
                ...values
            };
            await dispatch(updatePartMakeAsync(payload)).unwrap();
            successNotify('Part make updated successfully');
            onHide();
            
            // Refresh table and overview
            dispatch(fetchPartMakes({
                page: currentPage,
                limit: limit,
                body: {}
            }));
            dispatch(getPartMakesOverview());
        } catch (error) {
            errorNotify(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <CustomModal heading="Update Part Make" size="lg" show={show} handleClose={onHide}>
            <Formik
                initialValues={initialValues}
                validationSchema={partMakeValidationSchema}
                onSubmit={handleSubmit}
                enableReinitialize={true}
            >
                {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                    <Form>
                        <div className="add_user_modal">
                            <h5>Part Make Information</h5>
                            <div>
                                <Input
                                    label="Name"
                                    placeholder="Enter part make name"
                                    type="text"
                                    name="name"
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.name}
                                    touched={touched.name}
                                />
                            </div>

                            <div>
                                <Select
                                    label="Status"
                                    placeholder="Select status"
                                    options={partModelStatusOptions}
                                    name="status"
                                    value={partModelStatusOptions.find(opt => opt.value === values.status)}
                                    onChange={(option) => setFieldValue('status', option?.value || '')}
                                    onBlur={handleBlur}
                                    error={errors.status}
                                    touched={touched.status}
                                />
                            </div>

                            <div className="d-flex align-items-center gap-2" style={{ marginTop: "40px" }}>
                                <Button
                                    submitBtn={() => {}}
                                    loading={updatePartMakeLoading || isSubmitting}
                                    disabled={updatePartMakeLoading || isSubmitting}
                                    submitText="Update"
                                    type="submit"
                                    shouldRow={false}
                                    isShowSubmitBtn={true}
                                    isShowCancel={false}
                                />
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </CustomModal>
    );
};

export default UpdatePartMakeModal;
